import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "react-router";
import { qoAllWeekContents, qoHomeCurrent } from "../../utils/queryOptions";
import ModuleTitle from "./ModuleTitle";
import CurrentTasks from "./CurrentTasks";
import { ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "../../hooks/useAuth";
import ModuleQuizCard from "../moduleQuiz/ModuleQuizCard";
import { quizApi } from "../moduleQuiz/quizApi";

export default function AllWeeks({ cohortIds }: { cohortIds: number[] }) {
  const { user } = useAuth();
  const { data: allContents, isSuccess } = useQuery(
    qoAllWeekContents({ cohort_ids: cohortIds, user_id: user?.id })
  );
  // Ana sayfayla aynı: kaldığın ünite satırına yeşil "Devam Et" çipi
  const { data: home } = useQuery(qoHomeCurrent());
  const location = useLocation();

  // Modul sonu pratik durumlari TEK istekte — kartlar bunu prop olarak alir.
  const moduleIds = (allContents ?? []).map((cc) => cc.module_id);
  const { data: quizStatuses } = useQuery({
    queryKey: ["moduleQuizStatusBatch", moduleIds],
    queryFn: () => quizApi.statusBatch(moduleIds),
    enabled: moduleIds.length > 0,
    staleTime: 60 * 1000,
    retry: false,
  });

  useEffect(() => {
    if (!isSuccess || !location.hash) return;
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (!el) return;
    const timer = setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    return () => clearTimeout(timer);
  }, [isSuccess, location.hash]);

  return (
    <>
      <div className="mb-6 pl-12 lg:pl-0">
        <h1 className="text-xl sm:text-2xl font-semibold">Tüm Görevlerin</h1>
        <p className="text-white/40 text-sm mt-1">
          Tüm modüllerdeki derslerin ve projelerin burada listeleniyor.
        </p>
      </div>

      <div className="box rounded-3xl overflow-hidden">
        <div className="p-4 sm:p-6">
          <div className="flex flex-col-reverse">
            {isSuccess
              ? allContents.map((cc) => (
                <div key={cc.module_cohort_id} className="mb-5 last:mb-0">
                  <ModuleTitle cc={cc} />
                  <CurrentTasks currentModule={cc} resumeId={home?.resumeUnitId} />
                  <ModuleQuizCard
                    moduleId={cc.module_id}
                    status={quizStatuses?.find((s) => s.moduleId === cc.module_id) ?? null}
                  />
                </div>
              ))
              : (
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="bg-white/5 rounded-2xl h-16 animate-pulse" />
                  ))}
                </div>
              )}
          </div>

          <div className="text-left mt-3">
            <Link
              to="/"
              className="inline-flex text-white/50 hover:text-myGreen font-semibold items-center gap-1.5 py-2 px-3 rounded-lg hover:bg-white/5 transition-all text-sm"
            >
              <ArrowLeft size="16" weight="bold" />
              <span>Bu haftaya geri dön</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
